export const MIN_TIME_LEFT_FOR_TRADE_MS = 1000;
export const PAGES_DEFAULT = [1, 2, 3, 4, 5];
